<template>
  <Modal class="place-modal" :title="$t('modals.place.title')" @close="$emit('close')">
    <template #text>
      <div class="place-modal__text">
        <img class="place-modal__text-img" src="@/assets/images/modal/place.svg" alt="aqua image" />
        <span>
          {{ text }}
        </span>
      </div>
      <div class="place-modal__instruction">
        <div>
          <span>{{ subText }}</span>
          <Button
            @click="openChat"
            class="place-modal__instruction-button"
            size="md"
            type="secondary"
            left-icon="/modal/headphone.svg"
          >
            {{ $t('modals.place.help') }}
          </Button>
        </div>
        <picture>
          <source srcset="./gif/place-mobile.gif" media="(max-width: 599px)" />
          <source srcset="./gif/place.gif" media="(min-width: 600px)" />
          <img src="./gif/place.gif" alt="Responsive Image" />
        </picture>
      </div>
    </template>
    <template #footer>
      <Button type="secondary" @click="fetchPlaces">
        {{ $t('modals.place.continue') }}
      </Button>
      <Button @click="goToRoblox">
        {{ $t('modals.place.submit') }}
      </Button>
    </template>
  </Modal>
</template>

<script>
import './placeModal.scss'
import Modal from '@/components/Base/Modal/modal.vue'
import Button from '@/components/Base/Button/Button.vue'
import { openChat } from '@/utils/chat'
import windowSize from '@/mixins/windowSize'

export default {
  name: 'PlaceModal',
  mixins: [windowSize],
  components: {
    Button,
    Modal
  },
  props: {
    robloxUserId: {
      type: String
    },
    placesLength: {
      type: Number
    },
    fetchPlaces: {
      type: Function
    }
  },
  computed: {
    text() {
      return this?.screenWidth < 743 ? this.$t('modals.place.textMob') : this.$t('modals.place.text')
    },
    subText() {
      return this?.screenWidth < 743 ? this.$t('modals.place.subTextMob') : this.$t('modals.place.subText')
    }
  },
  methods: {
    openChat,
    goToRoblox() {
      window.open('https://create.roblox.com/dashboard/creations', '_blank')
    }
  }
}
</script>
